export function createFormData(formValues: any) {
  const formData = new FormData();

  function appendFormData(data: any, formData: FormData, parentKey?: string) {
    if (data instanceof File) {
      if (parentKey !== undefined) {
        formData.append(parentKey, data);
      }
      return;
    }

    if (data && typeof data === 'object') {
      Object.keys(data).forEach((key) => {
        const currentKey = parentKey ? `${parentKey}.${key}` : key;
        appendFormData(data[key], formData, currentKey);
      });
      return;
    }

    if (data !== null && data !== undefined && parentKey !== undefined) {
      formData.append(parentKey, data);
    }
  }

  appendFormData(formValues, formData);
  return formData;
}
